import React from "react";
import { VscEdit } from "react-icons/vsc";
import { RiDeleteBin6Line } from "react-icons/ri";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";

import {
  editMapping,
  storeDeleteMappedItem,
} from "../../store/slice/mappingSlice";

const MappedRows = ({
  mappedItem,
  selectDefaultProperty,
  setShowDeleteModal,
}) => {
  const dispatch = useDispatch();

  const storedKey = useSelector((state) => state.mapping.storedKey);

  const onEditMapping = (value) => {
    dispatch(editMapping(value));
  };

  return (
    <>
      <td className="vat-name-container ps-4">
        <span className="my-auto vat-label">{mappedItem[0]}</span> <br />
        <span className="my-auto description">
          {mappedItem[1].vatFieldDescription}
        </span>
      </td>
      <td>
        {mappedItem[1].key === "undefined" ? (
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip>This field is not required</Tooltip>}
          >
            <span
              className="my-auto ms-2"
              style={{
                fontSize: "14px",
                fontWeight: "400",
                cursor: "pointer",
                color: "grey",
              }}
            >
              Not Mapped
            </span>
          </OverlayTrigger>
        ) : (
          <p
            className={
              selectDefaultProperty(mappedItem[1]).name ===
              "custom property is deleted"
                ? "my-auto pd-label pd-deleted-label ms-2"
                : "my-auto pd-label ms-2"
            }
          >
            {selectDefaultProperty(mappedItem[1]).name}
          </p>
        )}
      </td>
      <td className="d-flex flex-row justify-content-center actions-column">
        <div className="mt-2">
          <button
            className="actions-btn"
            onClick={() => onEditMapping(mappedItem[0])}
            disabled={storedKey ? storedKey !== mappedItem[0] : ""}
          >
            <VscEdit size={16} />
          </button>
          {mappedItem[1].key === "undefined" ? (
            <button className="actions-btn" disabled>
              <RiDeleteBin6Line size={16} />
            </button>
          ) : (
            <button
              className="actions-btn"
              disabled={
                mappedItem[1]?.required === true ||
                (storedKey ? storedKey !== mappedItem[0] : "")
              }
              onClick={() => {
                setShowDeleteModal(true);
                dispatch(storeDeleteMappedItem(mappedItem[0]));
              }}
            >
              <RiDeleteBin6Line size={16} />
            </button>
          )}
        </div>
      </td>
    </>
  );
};

export default MappedRows;
